import axios from 'axios';
import { BASE_URL, request } from '../../Common/api/client';

export function getCpPaymentLinkConfig() {
  return request({ method: 'GET', url: '/api/cp/payment-links/config' });
}

export function createCpPaymentLink(payload) {
  return request({ method: 'POST', url: '/api/cp/payment-links', data: payload });
}

export function sendCpPaymentLinkSms(id, recipientPhone) {
  return request({
    method: 'POST',
    url: `/api/cp/payment-links/${id}/send-sms`,
    data: { recipientPhone },
  });
}

export function getCpPaymentLinks(params = {}) {
  return request({ method: 'GET', url: '/api/cp/payment-links', params, timeout: 10000 });
}

export function getCpPaymentLink(id) {
  return request({ method: 'GET', url: `/api/cp/payment-links/${id}` });
}

export function revokeCpPaymentLink(id, reason) {
  return request({ method: 'POST', url: `/api/cp/payment-links/${id}/revoke`, data: { reason } });
}

export function reissueCpPaymentLink(id, recipientPhone) {
  return request({ method: 'POST', url: `/api/cp/payment-links/${id}/reissue`, data: { recipientPhone } });
}

async function publicRequest({ method = 'GET', url, data }) {
  try {
    const response = await axios({
      method,
      url: `${BASE_URL}${url}`,
      data,
      withCredentials: false,
      ...(method === 'GET' ? { timeout: 10000 } : {}),
      headers: { 'Content-Type': 'application/json' },
    });
    const body = response?.data ?? {};
    if (Number(body.code) !== 1000) {
      const error = new Error(body.msg || '요청을 처리하지 못했습니다.');
      error.code = body.code;
      error.data = body.data;
      throw error;
    }
    return body.data;
  } catch (error) {
    const body = error?.response?.data;
    if (body && body.code !== undefined) {
      error.code = body.code;
      error.data = body.data;
      if (body.msg) error.message = body.msg;
    }
    throw error;
  }
}

export function getPublicPaymentLink(token) {
  return publicRequest({ method: 'GET', url: `/api/public/payment-links/${encodeURIComponent(token)}` });
}

export function verifyPublicPaymentLink(token, phoneLast4) {
  return publicRequest({
    method: 'POST',
    url: `/api/public/payment-links/${encodeURIComponent(token)}/verify`,
    data: { phoneLast4 },
  });
}

export function payPublicPaymentLink(token, payload) {
  return publicRequest({ method: 'POST', url: `/api/public/payment-links/${encodeURIComponent(token)}/pay`, data: payload });
}

export function getPublicPaymentLinkReceipt(token, phoneLast4) {
  return publicRequest({
    method: 'POST',
    url: `/api/public/payment-links/${encodeURIComponent(token)}/receipt`,
    data: { phoneLast4 },
  });
}
